"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AuthError;
// eslint-disable-next-line no-unused-vars
function AuthError(code, message) {
  var instance = new Error(message);
  instance.message = message;
  instance.code = code;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, AuthError);
  }
  return instance;
}
AuthError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
if (Object.setPrototypeOf) {
  Object.setPrototypeOf(AuthError, Error);
} else {
  AuthError.__proto__ = Error;
}